import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { Content_HRM1060_R01 } from './Content_HRM1060_R01';
import { HRM1060_R01Dto } from './Dto_HRM1060_R01';
import { Preview_HRM1060_R01 } from './Preview_HRM1060_R01';
import { SearchSection_HRM1060_R01 } from './SearchSection_HRM1060_R01';
import { Table_HRM1060_R01 } from './Table_HRM1060_R01';

/** 발급대장과 미리보기 사이의 분할 비율을 저장하는 설정이다. */
const WIDTH_RESIZER = {
    code: 'HRM1060_R01',
    type: 'width',
    storageKey: 'HRM1060_R01-split-width',
    min: 25,
    max: 75,
    default: 50,
} as const;

/** 액션바·검색·대장·A4 미리보기를 조립한다. @returns HRM1060 화면 */
export const Container_HRM1060_R01 = () => {
    const gridRef = useRef<AgGridReact<HRM1060_R01Dto>>(null); // 편집 확정과 행 이동용 그리드 ref
    const containerRef = useRef<HTMLDivElement>(null); // 좌우 분할 비율 계산의 기준 영역
    const previewRef = useRef<HTMLDivElement>(null); // 오른쪽 PDF 미리보기 영역
    const isResizing = useRef(false); // true이면 경계선을 드래그하는 중
    const { splitValue, handleMouseDown } = useMouseContent({
        resizer: WIDTH_RESIZER,
        isResizing,
        containerRef,
        infoRef: previewRef,
    }); // 저장된 비율과 공통 드래그 동작
    const { setMessage } = useUiuxStore(); // 하단 상태 메시지 변경
    const {
        fetchData, defaultHRM1060_R01Row, initContainerData, handleInsertClick,
        handleSaveClick, handleDeleteClick, handleExcelClick, handlePrintClick,
    } = Content_HRM1060_R01({ gridRef, setMessage }); // 화면 업무 함수

    return (
        <div className="content-container">
            {/* 기존 화면과 같은 권한별 액션바이다. */}
            <Actionbar onFetchClick={fetchData} onCreateClick={handleInsertClick}
                onDeleteClick={handleDeleteClick} onSaveClick={handleSaveClick}
                onPrintClick={handlePrintClick} onExcelClick={handleExcelClick}
                onInitClick={initContainerData} />
            {/* 신청년도·증명서·상태·사원 검색 조건이다. */}
            <SearchSection_HRM1060_R01 fetchData={fetchData} />
            {/* 발급대장과 PDF 미리보기 사이를 드래그해 너비를 조절한다. */}
            <div className="flex flex-1 min-h-0 p-[12px] gap-[4px]" ref={containerRef}>
                <div className="min-w-0 min-h-0 h-full flex flex-col"
                    style={{ flex: `${splitValue} 1 0%` }}>
                    <Table_HRM1060_R01 gridRef={gridRef}
                        defaultHRM1060_R01Row={defaultHRM1060_R01Row()}
                        handleInsertClick={handleInsertClick} />
                </div>
                {/* 기존 HRM 화면과 같은 공통 좌우 리사이저이다. */}
                <div className="w-[6px] h-full shrink-0 bg-gray-100 cursor-col-resize hover:bg-gray-300"
                    onMouseDown={event => handleMouseDown('LR', event.nativeEvent)} />
                <div className="min-w-0 min-h-0 h-full flex flex-col" ref={previewRef}
                    style={{ flex: `${100 - splitValue} 1 0%` }}>
                    <Preview_HRM1060_R01 handlePrintClick={handlePrintClick} />
                </div>
            </div>
            {/* 조회·저장 결과를 표시한다. */}
            <Message />
        </div>
    );
};
